<template>
    <BasePanel 
        headline="lang_ACCOUNT_COMPANIES_CAPTION_LABELCOMPANIES_PANEL"
        :alvqa="alvqa"
    >            
        <template v-slot:panelContent>
            <v-data-table
                :headers="headers"
                :items="items"
                :items-per-page="itemsPerPage"
                :header-props="{ sortIcon: '' }"
                hide-default-footer
                :no-data-text="$t('lang_GENERAL_MESSAGE_NO_RECORDS_FOUND')"
            >
                <template v-slot:top>
                    <v-row class="pb-3">
                        <v-spacer></v-spacer>
                        <v-col cols="3">
                            <BaseButton 
                                @click="addNewRow()"
                                label="lang_GENERAL_BUTTON_ADD_ROW"
                                block
                                :disabled="false"
                                :alvqa="alvqa + '-button-add-row'"
                            />
                        </v-col>
                    </v-row>
                </template>

                <!-- Headers -->
                <template v-for="(header, i) in headers" v-slot:[`header.${header.value}`]>
                    <span :alvqa="header.alvqa" :key="i">{{ header.text }}</span>
                </template>

                <!-- Items -->
                <template v-slot:[`item.companyName`]="{ item }">
                    <div :alvqa="alvqa + '-list-row-' + item.id + '-text-rights'">
                        {{ item.companyName }}
                    </div>
                </template>

                <template v-slot:[`item.alvId`]="{ item }">
                    <div :alvqa="alvqa + '-list-row-' + item.id + '-text-alvid'">
                        {{ item.alvId }}
                    </div>
                </template>

                <!-- Row Button: DELETE  -->
                <!-- <template v-slot:[`item.delete`]="{ item }">
                    <BaseIcon 
                        @click="deleteLabelCompanies(item)"
                        icon="delete"
                        color="iconDelete"
                        tooltipText="lang_GENERIC_CAPTION_DELETE"
                        :alvqa="alvqa + 'list-row-' + item.id + '-icon-delete'"
                    />
                </template> -->

                <!-- Row Button: EDIT -->
                <template v-slot:[`item.inlineEdit`]="{ item }">
                    <BaseIcon   
                        :alvqa="alvqa + '-list-row-' + item.id + '-icon-inline-edit'"
                        icon="edit" 
                        tooltipText="lang_GENERAL_CAPTION_ICON_EDIT"   
                        @click.stop="editInlineFunction(item)"
                    />
                </template>
                <template v-slot:[`item.uploadPicture`]="{ item }">
                    <BaseIcon
                        :alvqa="alvqa + '-list-row-' + item.id + '-icon-upload-picture'"
                        icon="photo"
                        :tooltipText="item.logo ? 'lang_GENERAL_CAPTION_ICON_EDIT_LOGO':'lang_GENERAL_CAPTION_ICON_UPLOAD_LOGO'"
                        :color="item.logo ? 'buttonStandard' : 'standardBrownIcon'"
                        @click.stop="showImageUploadDialog(item)"
                    />
                </template>

                <!-- Row Button: DEFAULT MAPPINGS -->
                <template v-slot:[`item.defaultMappings`]="{ item }">
                    <BaseIcon
                        :alvqa="alvqa + '-list-row-' + item.id + '-icon-default-mappings'"
                        icon="tune"
                        tooltipText="lang_ACCOUNT_COMPANY_CAPTION_DEFAULT_MAPPINGS_HEADLINE"
                        @click.stop="openDefaultMappingsDialog(item)"
                    />
                </template>
            </v-data-table>
        </template>
    </BasePanel>
</template>

<script>
import BasePanel from '@/components/_base/BasePanel'
import BaseIcon from '@/components/_buttons/BaseIcon'
import BaseInlineEditingDataTable from "@/components/_base/BaseInlineEditingDataTable"
import BaseButton from '@/components/_buttons/BaseButton'

export default {
    name: "LabelCompaniesEditPanel",  
    components: { 
        BasePanel,
        BaseIcon,
        BaseInlineEditingDataTable,
        BaseButton
    },
    data() {
        return {
            alvqa: 'account-companies-edit-form-panel-label-companies'
        }
    },
    computed: {
        items() { 
            // this.$store.commit('setIsLoading', true)
            // this.$store.dispatch('fetchAccountLabelCompanies')
            return this.$store.getters.getAccountLabelCompanies 
        },
		/** Returns an Array with header-objects with props.
         *  @return {[{text: String, align: string, value: string}]} props of the header */
        headers() {
            return [
                {   text: this.$t('lang_GENERIC_ACCOUNT_COMPANIES_CAPTION_COMPANY_NAME'), 
                    alvqa: this.alvqa + "header-company-name",
                    align: "left", 
                    sortable: true, 
                    value: "companyName", 
                    class: 'text-no-wrap'
                },
                {   
                    text: this.$t('lang_CAPTION_ALVID'), 
                    alvqa: this.alvqa + "header-alvid",
                    align: "left", 
                    value: "alvId", 
                    tooltip: "", 
                    class: 'text-no-wrap'
                },
                {
                    text: '',
                    value: 'uploadPicture',
                    align: 'right',
                    sortable: false,
                    width: "70px",
                    class: 'text-no-wrap'
                },
                {
                    text: '',
                    value: 'defaultMappings',
                    align: 'right',
                    sortable: false,
                    width: "70px",
                    class: 'text-no-wrap'
                },
                {
                    text: '',
                    value: 'inlineEdit',
                    align: 'right',
                    sortable: false,
                    width: "70px",
                    class: 'text-no-wrap'
                },
                // {
                //     text: "",
                //     align: "right",
                //     width: "70px",
                //     value: "delete",
                //     sortable: false,
                //     class: 'text-no-wrap'
                // }

            ]
        },
        itemsPerPage() { return this.$store.getters.getItemsPerPage },
    },
    methods: {

        addNewRow(){
            this.$store.commit('setShowPayableConfirmationDialog', true)
            this.$store.commit('setAddNewLabelCompany', true)
        }, 

        editInlineFunction(item) {
            this.$store.commit('setSelectedAccountLabelCompanies', item.id)
            let detailsDeepCopy = JSON.parse(JSON.stringify(item))
            // set the copy in dialog details to edit
            this.$store.commit('setAccountLabelCompaniesEditingDialogDetails', detailsDeepCopy)
            this.$store.commit('setEditingDialogHeadline', this.$t("lang_GENERAL_CAPTION_EDITING_ENTRY")) // set headline
            this.$store.commit('setShowAccountLabelCompaniesEditingDialog', true) 
        },
        
        showImageUploadDialog(item){
            this.$store.commit('setImageUploaderContext','AccountLabelCompanies')
            if(item.logo !== null){
                this.$store.commit('setImageUploaderImageExists',true)
            }
            this.$store.commit('setSelectedAccountLabelCompanies', item)

            this.$store.commit("setShowImageUploadDialog",true)

        },

        openDefaultMappingsDialog(item) {
            this.$store.dispatch('openCompanyDefaultMappingsDialog', {
                companyId:   item.id,
                companyType: 'label',
                companyName: item.companyName,
            })
        },
    }
}
</script>
